<template>
	<screen class="setup-view" type="white">
		<template slot="header">
			<ui-header type="dark" @click="onDismiss" action="close-dark">
				<h2 slot="title">Setup Password</h2>
			</ui-header>
		</template>
		<div class="auth-content">
			<form v-on:submit.prevent="onSubmit">
				<p>
					Enter the password you would like to use for your account.
				</p>
				<label>
					<ui-input
						nativeType="password"
						placeholder="New Password"
						v-model="password"
					/>
				</label>
				<label>
					<ui-button native-type="submit" :loading="isLoading"
						>Submit</ui-button
					>
				</label>
			</form>
		</div>
	</screen>
</template>

<script>
import { mapActions } from 'vuex'
import { getUrlParams } from '../../utilities'
import UiButton from '../../ui/Button'
import UiHeader from '../../ui/Header'
import UiInput from '../../ui/Input'
import Screen from '../../ui/Screen'

export default {
	name: 'reset-password',
	components: { UiButton, UiInput, Screen, UiHeader },
	props: ['uuid'],
	data() {
		return {
			isLoading: false,
			password: '',
			email: null
		}
	},
	methods: {
		...mapActions(['resetPassword', 'logout']),
		onSubmit() {
			this.isLoading = true
			this.resetPassword({ token: this.uuid, password: this.password })
				.then(() => {
					this.isLoading = false
					this.$swal('Success', 'Your password has been set!').then(
						() => {
							this.navigate({ name: 'login' }, 'down')
						}
					)
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		},
		onDismiss() {
			this.navigate({ name: 'launch' }, 'down')
		}
	},
	mounted() {
		const urlParams = getUrlParams(window.location.href)
		this.email = decodeURIComponent(urlParams.email)
	}
}
</script>

<style lang="scss">
@import '../../styles/elements';
</style>
